import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StatComponent from './StatComponent';
import ClientProvider from './client';
export default createDemo(import.meta.url, StatComponent, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/creating-themed-components/demos/stat-component/StatComponent.js",
    "fileName": "StatComponent.js",
    "language": "javascript",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\n\nconst StatRoot = styled('div')(({ theme }) => ({\n  display: 'flex',\n  flexDirection: 'column',\n  gap: theme.spacing(0.5),\n  padding: theme.spacing(3, 4),\n  backgroundColor: theme.palette.background.paper,\n  borderRadius: theme.shape.borderRadius,\n  boxShadow: theme.shadows[2],\n  letterSpacing: '-0.025em',\n  fontWeight: 600,\n  ...theme.applyStyles('dark', {\n    backgroundColor: 'inherit',\n  }),\n}));\n\nconst StatValue = styled('div')(({ theme }) => ({\n  ...theme.typography.h3,\n}));\n\nconst StatUnit = styled('div')(({ theme }) => ({\n  ...theme.typography.body2,\n  color: theme.palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    color: 'inherit',\n  }),\n}));\n\nexport default function StatComponent() {\n  return (\n    <StatRoot>\n      <StatValue>19,267</StatValue>\n      <StatUnit>Active users / month</StatUnit>\n    </StatRoot>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 37,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\n\nconst StatRoot = styled('div')(({ theme }) => ({\n  display: 'flex',\n  flexDirection: 'column',\n  gap: theme.spacing(0.5),\n  padding: theme.spacing(3, 4),\n  backgroundColor: theme.palette.background.paper,\n  borderRadius: theme.shape.borderRadius,\n  boxShadow: theme.shadows[2],\n  letterSpacing: '-0.025em',\n  fontWeight: 600,\n  ...theme.applyStyles('dark', {\n    backgroundColor: 'inherit',\n  }),\n}));\n\nconst StatValue = styled('div')(({ theme }) => ({\n  ...theme.typography.h3,\n}));\n\nconst StatUnit = styled('div')(({ theme }) => ({\n  ...theme.typography.body2,\n  color: theme.palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    color: 'inherit',\n  }),\n}));\n\nexport default function StatComponent() {\n  return (\n    <StatRoot>\n      <StatValue>19,267</StatValue>\n      <StatUnit>Active users / month</StatUnit>\n    </StatRoot>\n  );\n}\n"
      ]
    ],
    "totalLines": 37,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
